import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

class DownloadReportTypeMenu extends Component {
  state = { isOpen: false };

  triggerRef = React.createRef();

  openMenu = () => this.setState({ isOpen: true });

  closeMenu = () => this.setState({ isOpen: false });

  handleBlur = event => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      this.closeMenu();
    }
  };

  handleKeyDown = event => {
    if (event.key === 'Escape') {
      this.closeMenu();
      if (this.triggerRef.current) this.triggerRef.current.focus();
    }
  };

  handleSelect = reportType => {
    this.props.onSelect(reportType);
    this.closeMenu();
  };

  render() {
    const { selectedReportType, t } = this.props;
    const { isOpen } = this.state;

    return (
      <div
        className="downloadReportTypeMenu"
        onMouseEnter={this.openMenu}
        onMouseLeave={this.closeMenu}
        onFocus={this.openMenu}
        onBlur={this.handleBlur}
        onKeyDown={this.handleKeyDown}
      >
        <button
          ref={this.triggerRef}
          type="button"
          className="downloadReportTypeTrigger"
          aria-haspopup="menu"
          aria-expanded={isOpen}
          onClick={() => this.setState({ isOpen: !isOpen })}
        >
          <span>{t('download-report')}</span>
          <ExpandMoreIcon
            className={`downloadReportTypeChevron${isOpen ? ' downloadReportTypeChevronOpen' : ''}`}
          />
        </button>
        {isOpen && (
          <div className="downloadReportTypeDropdownBridge">
            <div className="downloadReportTypeDropdown" role="menu">
              <button
                type="button"
                role="menuitem"
                className={`downloadReportTypeOption${selectedReportType === 'monthly' ? ' selected' : ''}`}
                onClick={() => this.handleSelect('monthly')}
              >
                {t('monthly-report')}
              </button>
              <button
                type="button"
                role="menuitem"
                className={`downloadReportTypeOption${selectedReportType === 'hourly' ? ' selected' : ''}`}
                onClick={() => this.handleSelect('hourly')}
              >
                {t('hourly-report')}
              </button>
              <button
                type="button"
                role="menuitem"
                className={`downloadReportTypeOption${selectedReportType === 'half-hourly' ? ' selected' : ''}`}
                onClick={() => this.handleSelect('half-hourly')}
              >
                {t('half-hourly-report')}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(DownloadReportTypeMenu);
